<template>
  <section>
    <drivers-header title="Еще" />
    <div class="driver">
      <div class="driver__title">Дополнительные разделы</div>
      <div class="driver__content">
        <div class="more flex-between-center" @click="$router.push({name: 'AutosMobile'})">
          <div class="more__info">
            <div class="more__info-title font-bold">Автомобили</div>
            <div class="font-normal">Зарегистрированные диспетчером</div>
          </div>
          <div class="more__picture flex-center">
            <img src="@/assets/img/new-truck-green.svg" alt="truck ">
          </div>
        </div>
        <div class="more flex-between-center" @click="$router.push({name: 'DriversMobile'})">
          <div class="more__info">
            <div class="more__info-title font-bold">Водители</div>
            <div class="font-normal">Зарегистрированные диспетчером</div>
          </div>
          <div class="more__picture flex-center">
            <img src="@/assets/img/new-persons.svg" alt="truck ">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import DriversHeader from '@/components/Drivers/DriversHeader/DriversHeader'
export default {
  name: 'MoreItemsMobile',
  components: { DriversHeader },
}
</script>

<style lang="sass" scoped>
@import "@/assets/styles/driver-styles.sass"
.more
  margin-bottom: 2rem
  padding: 1.6rem
  box-shadow: 0 0 10px rgba(132, 132, 132, 0.15)
  border-radius: 1.2rem
  cursor: pointer
  &__info
    margin-right: 1.4rem
    &-title
      margin-bottom: 0.4rem
  &__picture
    width: 4.6rem
    height: 4.6rem
    background: #EBF9EB
    border-radius: .8rem
    img
      width: 2.4rem
      height: 2.4rem
</style>
